import { createSelector } from '@ngrx/store';
import { deletedSelector } from './deleted.selector';
import * as fromDeletedOrders from '../reducers/deleted-orders.reducer';

export const selectDeletedOrders = createSelector(deletedSelector, (state) => state[fromDeletedOrders.featureKey]);

export const selectOrders = createSelector(selectDeletedOrders, fromDeletedOrders.getOrders);

export const selectTotalCountOrders = createSelector(selectDeletedOrders, fromDeletedOrders.getCountOrders);

export const selectOrdersLoading = createSelector(selectDeletedOrders, fromDeletedOrders.getLoading);
